export const PropertyGroups: Record<string, { title: string }> = {
  primary: {
    title: 'Properties',
  },
  classifications: {
    title: 'Classifications',
  },
  'backup-details': {
    title: 'Backup details',
  },
  'source-location': {
    title: 'Source location',
  },
  'backup-from': {
    title: 'Backup from',
  },
  'backup-to': {
    title: 'Backup to',
  },
  'restore-from': {
    title: 'Restore from',
  },
  'restore-to': {
    title: 'Restore to',
  },
};
